import React, {type PropsWithChildren} from 'react';

import styled from 'styled-components';

import {FineImageUploaderArea} from 'app/general/widgets/Uploaders/FineImageUploaderArea';

import type {NewlyAttachedImageOrVideoType} from 'app/general/types';

const ROW_HEIGHT = 48;

interface Props {
  onAddImage: (image: NewlyAttachedImageOrVideoType) => void;
}

export function ImageUploaderForDocuments({onAddImage}: Props) {
  return (
    <StyledUploaderDiv className="rounded p-4 align-items-center justify-content-center d-flex mb-2 flex-column">
      <FineImageUploaderArea
        buttonClassName="btn-outline-secondary"
        renderUploadList={(component) => (
          <ImageUploads className="mt-2">{component}</ImageUploads>
        )}
        onAddImage={onAddImage}
      />
    </StyledUploaderDiv>
  );
}

function ImageUploads({
  className,
  children,
}: PropsWithChildren<{className?: string}>) {
  return (
    <StyledSection className={className}>
      <div className="table-body">{children}</div>
    </StyledSection>
  );
}

const StyledUploaderDiv = styled.div`
  border: 2px dashed rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.3);

  .react-fine-uploader-file-input-container {
    display: flex !important;
    justify-content: center;
    margin-top: 0.5em;
  }

  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border: 2px dashed rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.4);
  }
`;

const StyledSection = styled.section`
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
  overflow: hidden;

  .table-body > ul.uploads-list > li {
    align-items: center;
    min-height: ${ROW_HEIGHT}px;
    padding: 0.5em !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    background: #fff;
  }

  .table-body i.fa-check {
    color: var(--success);
  }

  .table-body i.fa {
    margin-right: 1em;
  }

  .table-body .react-fine-uploader-filename {
    white-space: nowrap;
    width: 10rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .table-body .list-unstyled .pb-2 {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .table-body .react-fine-uploader-filesize {
    white-space: nowrap;
  }

  .table-body > ul.uploads-list > li > .progress {
    width: 3rem;
    height: 8px;
    overflow: hidden;
    align-self: center;
    font-size: 0;
  }
`;
